(function () {

    const tipNode = $('.tip');
    const clickedEl = tipNode.find('.tip__click')

    if (tipNode.length > 0) {

        clickedEl.on('click', function () {
            const thisTip = $(this).parents('.tip');
            const relativeBlock = thisTip.find('.tip__relative');
            const clickBlock = thisTip.find('.tip__click');
            const tipPopup = thisTip.find('.tip__popup');

            //25px добавляем, что бы сместить ниже кликаемого блока
            const diff = (clickBlock.offset().top - relativeBlock.offset().top) + 25

            tipPopup.css('top', diff);
            thisTip.toggleClass('active');
        })
    }
})();
